export default "__VITE_ASSET__D8vkFY8P__"